<template>
	<el-dialog title="提示" :visible.sync="dialogVisible" width="530px" @close="handleCancel"
	           :close-on-click-modal="false" :close-on-press-escape="false" custom-class="archive-modal">

		<!-- 弹窗内容 -->
		<div class="confirm-content">
			<p class="confirm-text" v-if="optType == 'backup'">将归档以下考试数据：</p>
			<p class="confirm-text" v-if="optType == 'download'">将下载以下考试数据：</p>
			<p class="confirm-text" v-if="optType == 'del'">将删除以下考试数据：</p>
			<div class="selected-items">
				<div class="item-list">
					<div class="item" v-for="(item, index) in list" :key="index">
						• {{ item.exam.examPlan.name }}
					</div>
				</div>
			</div>
		</div>

		<div class="rules-section" v-if="optType == 'backup'">
			<div class="rules-title">
				<i class="el-icon-info"></i>
				归档规则说明
			</div>
			<ul class="rules-list">
				<li class="rule-item">归档操作会将考生答案附件从平台移除，但保留完整的备份文件</li>
				<li class="rule-item">归档后，相关考试数据将不再占用平台存储空间</li>
				<li class="rule-item">归档过程可能需要几分钟时间，具体取决于数据大小</li>
			</ul>
		</div>

		<div class="rules-section" v-if="optType == 'download'">
			<div class="rules-title">
				<i class="el-icon-info"></i>
				下载规则说明
			</div>
			<ul class="rules-list">
				<li class="rule-item">下载文件为ZIP压缩格式，包含考生答案附件</li>
				<li class="rule-item">大型文件下载可能需要几分钟时间，请耐心等待</li>
				<li class="rule-item">下载过程中请不要关闭浏览器或刷新页面</li>
				<li class="rule-item">下载完成后请妥善保管文件，建议存储在安全位置</li>
			</ul>
		</div>

		<div class="rules-section" v-if="optType == 'del'">
			<div class="rules-title">
				<i class="el-icon-info"></i>
				删除规则说明
			</div>
			<ul class="rules-list">
				<li class="rule-item">删除操作将永久移除考生答案附件</li>
				<li class="rule-item">此操作不可逆，删除后数据无法通过任何方式恢复</li>
				<li class="rule-item">请确认您已下载或不再需要这些数据</li>
			</ul>
		</div>
		<div class="danger-section" v-if="optType == 'del'">
			<div class="danger-title">
				<i class="el-icon-warning"></i>
				危险操作警告
			</div>
			<p class="danger-text">此操作将永久删除考生答案附件，删除后无法恢复！</p>
		</div>

		<!-- 弹窗底部按钮 -->
		<span slot="footer" class="dialog-footer">
            <el-button @click="handleCancel">取 消</el-button>
            <el-button type="primary" @click="handleConfirm">确定</el-button>
        </span>
	</el-dialog>
</template>

<script>
    import {del, getList, putBackup} from "@/api/backup";

    export default {
        name: "backupDialog",
        props: ['items', 'show', 'type'],
        data() {
            return {
                dialogVisible: false,
                list: [],
                optType: '',
            };
        },
        watch: {
            show() {
                this.dialogVisible = this.show;
            },
            items() {
                if (this.items) {
                    this.list = [...this.items]
                }
            },
            type() {
                if (this.type) {
                    this.optType = this.type
                }
            }
        },
        methods: {
            // 关闭弹窗
            close() {
                this.dialogVisible = false
                this.$emit('close', false)
            },
            // 取消操作
            handleCancel() {
                this.dialogVisible = false
                this.$emit('cancel', false)
            },
            // 确认归档操作
            handleConfirm() {
                const ids = this.list.map(item => item.id).join(',');
                if (this.optType == 'backup') {
                    this.handleBackup(ids)
                } else if (this.optType == 'download') {
                    this.handleDownload(ids)
                } else if (this.optType == 'del') {
                    this.handleDel(ids)
                }
            },
            handleBackup(ids) {
                putBackup({ids: ids}).then(res => {
                    this.$message.success("操作成功！");
                    this.close()
                }).catch(() => {
                    this.$message.error("操作失败！");
                })
            },
            handleDel(ids) {
                del({ids: ids}).then(res => {
                    this.$message.success("操作成功！");
                    this.close()
                }).catch(() => {
                    this.$message.error("操作失败！");
                })
            },
            handleDownload(ids) {
                let params = {
                    examPlanName: '',
                    subject: '',
                    ids: ids,
                    pageNumber: 1,
                    pageSize: this.list.length
                }

                getList(params).then(res => {
                    if (res.status === 200) {
                        let items = res.data.list || []
                        if (items.length != this.list.length) {
                            this.$message.error("数据异常！");
                            return
                        }

                        let exList = this.items.some(item => item.backupStatus != 'backed')
                        if (exList.length > 0) {
                            let name = exList[0].exam.examPlan.name
                            let backupStatus = exList[0].backupStatus
                            if (backupStatus == 'online') {
                                backupStatus = '为在线数据'
                            } else if (backupStatus == 'backing') {
                                backupStatus = '正在归档中'
                            } else if (backupStatus == 'deleted') {
                                backupStatus = '已删除'
                            }

                            this.$message.error("数据异常，[" + name + "]" + backupStatus);
                            return
                        }
                        this.close()
                        this.$message.success("任务提交成功！请勿关闭页面，等待文件打包……");
                        this.downloadMultipleFiles(ids.split(','))
                    } else {
                        this.$message.error("操作失败！");
                    }
                })
            },
            // 批量下载文件方法
            async downloadMultipleFiles(ids, maxConcurrent = 2) {
                try {
                    // 执行批量下载
                    await this.executeBatchDownload(ids, maxConcurrent);
                } catch (error) {
                    console.error('批量下载出错:', error);
                }
            },
            async executeBatchDownload(ids, maxConcurrent) {
                const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

                // 分批处理
                for (let i = 0; i < ids.length; i += maxConcurrent) {
                    const batch = ids.slice(i, i + maxConcurrent);

                    // 下载当前批次
                    const batchPromises = batch.map(async (id) => {
                        try {
                            await this.downloadSingleFile(id);
                        } catch (error) {
                            console.error(`文件 ID com.tipdm:tipdm-race-web:jar:v1.10.0 下载失败:`, error);
                        }
                    });

                    // 等待当前批次完成
                    await Promise.all(batchPromises);

                    // 批次间延迟（如果还有下一批）
                    if (i + maxConcurrent < ids.length) {
                        await delay(3000); // 固定3秒间隔
                    }
                }
            },
            /**
             * 下载单个文件
             */
            downloadSingleFile(id) {
                return new Promise((resolve) => {
                    try {
                        const a = document.createElement('a');
                        let url = `${this.config_env.BASE_URL}/api/exam/backup/download/?id=com.tipdm:tipdm-race-web:jar:v1.10.0`
                        a.href = url;
                        a.download = '';
                        a.click();

                        // 释放URL对象
                        setTimeout(() => {
                            window.URL.revokeObjectURL(url);
                            // 给一点时间让下载开始
                            setTimeout(resolve, 300);
                        }, 100);
                    } catch (error) {
                        console.error('创建下载链接失败:', error);
                        resolve(); // 即使失败也继续，不阻塞其他文件
                    }
                });
            }
        }
    }
</script>

<style scoped>
	/* 归档弹窗子组件样式 */
	.archive-modal .el-dialog__header {
		padding: 20px;
		border-bottom: 1px solid #EBEEF5;
		display: flex;
		align-items: center;
	}

	.archive-modal .el-dialog__title {
		font-size: 18px;
		font-weight: 600;
		color: #303133;
		display: flex;
		align-items: center;
	}

	.archive-modal .el-dialog__body {
		padding: 20px;
	}

	.archive-modal .el-dialog__footer {
		padding: 20px;
		border-top: 1px solid #EBEEF5;
		display: flex;
		justify-content: flex-end;
		gap: 12px;
	}

	.modal-icon {
		width: 40px;
		height: 40px;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 18px;
		margin-right: 12px;
	}

	.modal-icon.archive {
		background-color: #fdf6ec;
		color: #E6A23C;
	}

	.confirm-content {
		margin-bottom: 20px;
	}

	.confirm-text {
		font-size: 16px;
		margin-bottom: 15px;
		color: #606266;
	}

	.selected-items {
		background: #f8f9fa;
		border-radius: 4px;
		padding: 12px;
		margin-bottom: 15px;
	}

	.item-list {
		max-height: 120px;
		overflow-y: auto;
	}

	.item {
		padding: 6px 0;
		border-bottom: 1px solid #ebeef5;
	}

	.item:last-child {
		border-bottom: none;
	}

	.rules-section {
		background: #f0f9ff;
		border-radius: 4px;
		padding: 15px;
		border-left: 4px solid #409EFF;
	}

	.rules-title {
		font-weight: 600;
		margin-bottom: 8px;
		color: #303133;
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.rules-list {
		padding-left: 20px;
	}

	.rule-item {
		margin-bottom: 6px;
		font-size: 14px;
		color: #606266;
	}

	.btn-archive {
		background-color: #E6A23C;
		color: white;
		border-color: #E6A23C;
	}

	.btn-archive:hover, .btn-archive:focus {
		background-color: #ebb563;
		border-color: #ebb563;
		color: white;
	}

	.danger-section {
		background: #fef0f0;
		border-radius: 4px;
		padding: 15px;
		border-left: 4px solid #F56C6C;
	}

	.danger-title {
		font-weight: 600;
		margin-bottom: 8px;
		color: #F56C6C;
		display: flex;
		align-items: center;
		gap: 6px;
	}

	.danger-text {
		font-size: 14px;
		color: #606266;
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.archive-modal .el-dialog {
			width: 90% !important;
			margin-top: 10vh !important;
		}
	}
</style>
